import React from 'react';
import ReactPaginate from 'react-paginate';
import './Pagination.scss';
import { connect } from 'react-redux';
import classNames from 'classnames';

type callBack = (pageSelected: number) => void;

interface PaginationStateProps {
  totalCountOfItems: number | undefined;
  callBack: callBack;
  currentPageOfItems: number;
}

const Pagination = ({
  totalCountOfItems,
  callBack,
  currentPageOfItems,
}: PaginationStateProps) => {
  const pageSize = 10;
  let pageCount = 1;

  if (totalCountOfItems && totalCountOfItems > pageSize) {
    pageCount = Math.ceil(totalCountOfItems / pageSize);
  } else {
    return null;
  }

  function handlePageClick({ selected: selectedPage }: { selected: number }) {
    callBack(selectedPage + 1);
  }

  return (
    <div className="container">
      <ReactPaginate
        pageCount={pageCount}
        previousLabel={'Previous'}
        nextLabel={'Next'}
        containerClassName={'pagination'}
        previousLinkClassName={'pagination__link'}
        nextLinkClassName={'pagination__link'}
        disabledClassName={classNames(
          'pagination__link--disabled',
          currentPageOfItems === 1 || currentPageOfItems === pageCount
            ? 'disable'
            : ''
        )}
        activeClassName={'pagination__link--active'}
        onPageChange={handlePageClick}
        forcePage={currentPageOfItems - 1}
        pageClassName={'on_hover_page'}
      />
    </div>
  );
};
export default connect<null, PaginationStateProps>(null)(Pagination);
